<script setup lang="ts">
import type { NuxtError } from '#app';

defineProps<{
  error: NuxtError;
}>();

const { t } = useI18n();

useSeoMeta({
  title: t('error.pageNotFound.title'),
  description: t('error.pageNotFound.description'),
});

useHead({
  htmlAttrs: {
    lang: 'en',
  },
});
</script>

<template>
  <UApp>
    <UError :error="error" />
  </UApp>
</template>
